module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts"
  }, [_c('ul', {
    staticClass: "item-list"
  }, [(!_vm.contactData.length) ? _c('li', {
    staticClass: "item center"
  }, [_vm._v("暂无联系人")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.contactData), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "infos"
    }, [_c('div', {
      staticClass: "user"
    }, [_c('a', {
      staticClass: "text",
      style: (_vm.titColor),
      on: {
        "click": function($event) {
          _vm.detail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.level))]), _vm._v(" "), (item.isMain) ? _c('span', {
      staticClass: "tag master"
    }, [_vm._v("关键决策人")]) : _vm._e(), _vm._v(" "), (_vm.mainContact) ? [(item.isMainContact) ? [_c('span', {
      staticClass: "tag mainContact"
    }, [_vm._v("主联系人")]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "主联系人只有一个，设置成功后将会在客户列表页便捷查看主联系人。",
        "placement": "bottom",
        "effect": "light"
      }
    }, [_c('span', {
      staticClass: "icon el-icon-question"
    })])] : _c('el-button', {
      staticClass: "button",
      attrs: {
        "type": "text",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.setMessageBox(item)
        }
      }
    }, [_vm._v("设为主联系人")])] : _vm._e()], 2), _vm._v(" "), _c('p', {
      staticClass: "phone"
    }, [_vm._v("Tel：" + _vm._s(_vm._f("arrToStr")(item.phone)))]), _vm._v(" "), _c('span', {
      staticClass: "position"
    }, [_vm._v(_vm._s(item.position))])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(_vm.showLoadmore) ? [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v("\n      加载更多\n    ")] : _vm._e(), _vm._v(" "), (!_vm.showLoadmore && _vm.page.total > _vm.page.size) ? [_vm._v("没有更多")] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b43a7df8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/customer/contact.vue
// module id = 1329
// module chunks = 82